import React from "react";

import "features/new/about/view.scss";

const AboutView = () => (
  <section className="main__about ">
    <div className="about__container about__container--2020">
      <h2 className="about__headline main__animation--fade-in">About Us</h2>
      <p className="about__description main__animation--fade-in">
        Parlor is a new way to socialize. Members enjoy a thoughtfully-curated
        calendar of online and offline events and the ability to connect with
        each other through our mobile app. Parlor members come from a variety of
        backgrounds creating a balanced mix of creatives, professionals and
        tastemakers.
      </p>
    </div>
  </section>
);

export default AboutView;
